import React from "react";

import logoBrazil from "../images/flag-brazil.png";

const Banner = () => {
  return (
    <div className="section_banner">
      <div className="banner-wrapper">
        <div className="banner">
          <img className="banner-bandeira" src={logoBrazil} alt="" width={26} height={27} />
          <span>
            Segunda Pesquisa Nacional das Criptomoedas
            <span className="banner-separador" aria-hidden="true">|</span>
            2026
          </span>
        </div>
      </div>
    </div>
  );
};

export default Banner;
